import React, { useEffect, useState, useRef, useContext } from "react";
import PropTypes from "prop-types";
import { PDF } from "components/Shared/MDropzone/utility/fileTypes";
import { addFile, deleteFile, getFileList } from "requests/appraiserCountyFiles";
import MCard from "components/Shared/MCard.tsx";
import { MDropzone } from "components/Shared";
import WebConfig from "middlewares/WebConfig";
import { DialogContext } from "components/Shared/DialogProvider.tsx";

const AppraiserCountyFileManager = ({ appraiserId, canEdit }) => {
  const [fileList, setFileList] = useState([]);

  const mounted = useRef(true);
  const dialog = useContext(DialogContext);
  
  const updateFiles = () => {
    setFileList([]);
    getFileList(appraiserId, files => {
      files.forEach(f => {
        f.canDelete = true;
        f.downloadUrl = WebConfig.webApiRoot + f.downloadUrl;
        f.viewUrl = WebConfig.webApiRoot + f.viewUrl;
      });
      setFileList(files);
    }, mounted);
  };

  useEffect(() => () => mounted.current = false, []);
  useEffect(() => {
    updateFiles();
  }, [appraiserId]);
  
  const rights = {
    download: true,
    preview: true,
    delete: canEdit,
  };

  const onFileAdd = files => {
    if (canEdit) addFile(appraiserId, files[0].file, updateFiles, mounted);
    else dialog.showOk("Cant Upload", "You do not have permission to upload files");
  };

  const onFileDelete = files => {
    let file = fileList.find(f => f.downloadUrl === files[0].downloadUrl);
    deleteFile(file.id, updateFiles, mounted);
  };

  const openFilePreview = (urlWithSSO) => {
    let tab = window.open(urlWithSSO, "_blank");
    tab.focus();
  };

  return (
    <MCard title="Appraiser County Proficiency File Manager">
      <MDropzone
        validFileTypes={PDF}
        existingFiles={fileList}
        multiple
        noClick
        onPreview={(file, urlWithSSO) => openFilePreview(urlWithSSO)}
        onFileAdd={onFileAdd}
        onFileRemove={onFileDelete}
        prompt="Drop Appraiser File here"
        fileRightOverrides={rights}
        columnDefinitionOverride={[
          { name: "Name", dataSource: "name", className: "file-name-cell" },
          { name: "Type", dataSource: "extension", style: { width: "50px" } },
          { name: "Actions", dataSource: "actions", style: { width: "160px" } },
        ]}
      />
    </MCard>);
};

AppraiserCountyFileManager.propTypes = ({
  appraiserId: PropTypes.number,
  canEdit: PropTypes.bool,
});

export default AppraiserCountyFileManager;
